import { updateObjectsInArray } from '../../helpers';

const ACTION_APPEND = 'append';
const ACTION_REPLACE = 'replace';

export const MediaFeed = {
  state: {
    mediaFeed: {
      mediaList: [],
      loading: false,
      refresh: false,
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
        last_page: 0,
      },
    },
  },
  getters: {
    getMediaList: (state) => {
      return state.mediaFeed.mediaList;
    },
    getMediaRefresh: (state) => {
      return state.mediaFeed.refresh;
    },
    getMediaPaginationData: (state) => {
      return state.mediaFeed.pagination;
    },
    getMediaBusy: (state) => {
      return state.mediaFeed.loading;
    },
  },
  mutations: {
    setMediaBusy(state, loading) {
      state.mediaFeed.loading = loading;
    },
    setMediaRefresh(state, refresh) {
      state.mediaFeed.refresh = refresh;
    },
    feedSetFollowingMedia(state, mediaId) {
      state.mediaFeed.mediaList = updateObjectsInArray(state.mediaFeed.mediaList, mediaId, 'id', { following: true });
    },
    feedSetUnFollowingMedia(state, mediaId) {
      state.mediaFeed.mediaList = updateObjectsInArray(state.mediaFeed.mediaList, mediaId, 'id', { following: false });
    },
    setMediaList(state, mediaList) {
      state.mediaFeed.mediaList.push(...mediaList);
    },
    replaceMediaList(state, mediaList) {
      state.mediaFeed.mediaList = mediaList;
    },
    setCurrentMediaPage(state, currentPage) {
      state.mediaFeed.pagination.current_page = currentPage;
    },
    setMediaPagination(state, pagination) {
      state.mediaFeed.pagination = {
        ...state.mediaFeed.pagination,
        current_page: pagination.current_page,
        total: pagination.total,
        last_page: pagination.last_page,
      };
    },
    removeMedia(state, id) {
      state.mediaFeed.mediaList = state.mediaFeed.mediaList.filter((el) => el.id !== id);
      state.mediaFeed.pagination.total = state.mediaFeed.mediaList.length;
    },
  },
  actions: {
    changeCurrentMediaPage({ state, commit, dispatch }, { groupId, page = 1 }) {
      if (page <= state.mediaFeed.pagination.last_page) {
        commit('setCurrentMediaPage', page);
        dispatch('requestMediaFeed', { groupId, page });
      }
    },
    changeMediaRefresh({ commit }, refresh) {
      commit('setMediaRefresh', refresh);
    },
    async requestMediaFeed({ state, commit }, { groupId, page = null, action = ACTION_APPEND }) {
      if (page <= state.mediaFeed.pagination.last_page || action === ACTION_REPLACE) {
        if (page !== null && page <= state.mediaFeed.pagination.last_page) {
          commit('setCurrentMediaPage', page);
        }
        let currentPage = state.mediaFeed.pagination.current_page;
        commit('setMediaBusy', true);

        const response = await this._vm.$api('group_video.index', {
          version: '1.0',
          caseGroup: groupId,
          page: currentPage,
        });
        if (action === ACTION_APPEND) {
          commit('setMediaList', response.data.data);
        }

        if (action === ACTION_REPLACE) {
          commit('replaceMediaList', response.data.data);
        }
        commit('setMediaPagination', response.data.meta);
        commit('setMediaBusy', false);
        commit('setMediaRefresh', false);
      }
    },

    removeMediaFromState({ commit }, id) {
      commit('removeMedia', id);
    },
  },
};
